// SuperStarInstrumentContext.js
import React, { createContext, useContext } from 'react';

export const SuperStarInstrumentContext = createContext();

export const SuperStarInstrumentProvider = ({
                                                children,
                                                SuperStarInstrument,
                                                tabID,
                                                setLayouts,
                                                layoutIndex,
                                                superStarNameMap,
                                                oneQtrInstrument,
                                                setSuperStarInstruments,
                                                onPriceDifferenceUpdate,
                                            }) => {
    return (
        <SuperStarInstrumentContext.Provider
            value={{
                SuperStarInstrument,
                tabID,
                setLayouts,
                layoutIndex,
                superStarNameMap,
                oneQtrInstrument,
                setSuperStarInstruments,
                onPriceDifferenceUpdate,
            }}
        >
            {children}
        </SuperStarInstrumentContext.Provider>
    );
};

export const useSuperStarInstrumentContext = () => useContext(SuperStarInstrumentContext);
